import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
